// extracted by mini-css-extract-plugin
export default {"ca":"index_ca__pB9au"};